import { Chains } from 'modules/blockChain/chains'
import * as generated from 'generated'
import { createContractHelpers } from 'modules/contracts/utils/createContractHelpers'

export const ContractInvestorRuSDC1 = createContractHelpers({
  name: 'InvestorRuSDC1',
  factory: generated.PoolInvestor__factory,
  version: '1.0.0',
  address: {
    [Chains.Matic]: '0x883F10Dc3960493f38F69b8696dC331D22fdEd76',
    [Chains.Polygon]: '0x883F10Dc3960493f38F69b8696dC331D22fdEd76',
  },
})

export const ContractInvestorRuSDC2 = createContractHelpers({
  name: 'InvestorRuSDC2',
  factory: generated.PoolInvestor__factory,
  version: '1.0.0',
  address: {
    [Chains.Matic]: '0x8bf2B880B48EA3d1b13677f327c5058480b4e1d0',
    [Chains.Polygon]: '0x8bf2B880B48EA3d1b13677f327c5058480b4e1d0',
  },
})

export const ContractInvestorRuSDC3 = createContractHelpers({
  name: 'InvestorRuSDC3',
  factory: generated.PoolInvestor__factory,
  version: '1.0.0',
  address: {
    [Chains.Matic]: '0x978F89dE413594378a68CB9C14a83CeC0cEC721b',
    [Chains.Polygon]: '0x978F89dE413594378a68CB9C14a83CeC0cEC721b',
  },
})
